import { render } from "./Layout.vue?vue&type=template&id=485d8fc4"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=485d8fc4&lang=scss"

import exportComponent from "/home/scotty/git/bmu-website/bmu-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__